import type {
  ConfigurationTask,
  ConfigurationTaskKey,
  ProjectConfigurationTask,
  ProjectConfigurationTaskStatus,
} from '../interfaces/configurationTask.interface';
import type { Project } from '../interfaces/project.interface';

export enum ProjectSocketEvents {
  ProjectUpdated = 'project-updated',
  JennyIntegrationUpdated = 'jenny-integration-updated',
  OnboardingTranscriptUpdated = 'onboarding-transcript-updated',
  ProjectBriefUpdated = 'project-brief-updated',
  BriefStatusChanged = 'brief-status-changed',
  ProjectCreated = 'project-created',
  ProjectSettingUpdated = 'project-setting-updated',
  ConfigurationTaskUpdated = 'configuration-task-updated',
}

export type ProjectSocketProjectDTO = { project_id: number; timestamp: number } & Pick<
  Project,
  'status' | 'brief_status' | 'brief_comments' | 'name'
>;

export type ProjectSocketConfigurationTaskDTO = {
  task_id: number;
  task_summary_id: number;
  task_task: ConfigurationTaskKey;
  previous_status: ProjectConfigurationTaskStatus;
  new_status: ProjectConfigurationTaskStatus;
  timestamp: number;
} & Pick<ProjectConfigurationTask, 'project_id' | 'notes' | 'updated_by'> &
  Pick<ConfigurationTask, 'order'>;
